import React from "react";
import { Calendar, MessageSquare, ShieldCheck, Gem } from "lucide-react";
import { TRUST, CONTACT } from "@/data/site";

const ICONS = { calendar: Calendar, chat: MessageSquare, shield: ShieldCheck, sparkle: Gem };

export default function TrustBar() {
  return (
    <section className="bg-ivory" aria-label="Why choose Golden Touch">
      <div className="mx-auto max-w-7xl px-3 sm:px-6 lg:px-10 py-8 sm:py-12">
        <div className="grid grid-cols-4 gap-1 sm:gap-4">
          {TRUST.map((item, i) => {
            const Icon = ICONS[item.icon] || Gem;
            const isText = item.icon === "chat";
            return (
              <div
                key={item.title}
                className={`flex flex-col items-center px-1 text-center sm:px-2 ${
                  i > 0 ? "border-l border-gold/40" : ""
                }`}
              >
                <Icon className="text-gold" size={22} strokeWidth={1.3} />
                <h3 className="mt-2 text-[0.6rem] font-semibold uppercase leading-tight tracking-[0.1em] text-onyx sm:mt-3 sm:text-[0.72rem] sm:tracking-[0.18em]">
                  {item.title}
                </h3>
                {isText ? (
                  <a
                    href={CONTACT.smsHref}
                    className="mt-1 text-[0.62rem] leading-snug text-charcoal/70 hover:text-gold transition-colors sm:mt-1.5 sm:text-xs"
                  >
                    {item.text}
                  </a>
                ) : (
                  <p className="mt-1 text-[0.62rem] leading-snug text-charcoal/70 sm:mt-1.5 sm:text-xs">
                    {item.text}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
